import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import Loader from '@components/loader/1'

const MOCKDATA: RealEstateDataPageComponentData = {
  title: 'Gestión integral de desarrollos inmobiliarios',
  subtitle: 'Innovación y tecnología aplicada al Real Estate.',
  paragraph: 'Nuestra trayectoria en el sector nos permite ofrecer una gestión segura, confiable y transparente. Guiados por una visión integral, abarcamos todas las etapas del desarrollo de proyectos inmobiliarios, asegurando que cada detalle se ajuste a los más altos estándares de excelencia y a las expectativas de aquellos que ven en nosotros una oportunidad para invertir y prosperar.'
}

const Services2 = (props: RealEstateDataPageComponentData) => {
  const { isDemo } = props
  const { title, subtitle, paragraph } = isDemo ? MOCKDATA : props
  const [load, setLoad] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 0)
  }, [])

  return (
    <section className="our-services-texts p-y-config">
      <Container fluid>
        {!load ? (
          <Row>
            {title ? (
              <Col xs={12}>
                <h2 className="section-title pb-2 text-center">{title}</h2>
              </Col>
            ) : null}
            {subtitle ? (
              <Col xs={12}>
                <h4 className="section-subtitle pb-4 text-center">{subtitle}</h4>
              </Col>
            ) : null}
            {paragraph ? (
              <Col xs={12}>
                <p className="section-paragraph text-center m-auto">{paragraph}</p>
              </Col>
            ) : null}
          </Row>
        ) : (
          <Loader />
        )}
      </Container>
    </section>
  )
}

export default Services2
